import React, {
	useState,
	useMemo,
	useRef,
	useEffect,
	useCallback,
} from "react";
import "./styles.scss";
import stylesHierachy from "../admin/styles.module.scss"
import { ConnectionTypes, dataBrowserTabs, dataTabsList, sourceTypeNameMapping, SourceTypes } from "./enums";
import classNames from "classnames";
import {
	ConnectionsTreeview,
	TableMetaData,
} from "./treeviews/connections-treeview";
import {
	RecordsInfo,
	RecordsInfoResponse,
	DataSourceHandler,
	PiRequestQuery,
	NiFiManagedConnectionInfo,
	AuditRequestHistoryType,
	ProgressLogsResponse,
	FileInfo
} from "../../api/data-source-handler";
import { PaginateRef } from "../../components/paginate";
import { ColumnManagementRhs } from "./column-management-rhs";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/types";
import { _selectoptionType } from "../../components/form/select-field";
import { QueryEditorBuilderModal } from "./modals/query-editor-builder";
import { setActionType, toggleDataBrowserModal } from "../../store/datasources";
import {
	Row,
	Col,
	DatePicker,
	Input,
	Button,
	Icon,
	Select,
	Form as AntForm,
} from "antd";
import { ShowWhenTrue } from "../../helpers";
import {
	ActiveSortColumn,
	AdjustToCellSizeTable,
} from "../../components/table/";
import {
	NewEditPiRequestModal,
	NewEditPiRequestModalTypes,
} from "./modals/new-edit-pi-request";
import { TablePagination } from "../../components/table/TablePagination";
import {
	PiManagedRequestsTable,
	PiRequestInfo,
	piRequestStateOptions,
	PiRequestStates,
} from "./pi-managed-requests-table";
import { InPageSpinner } from "../../components/spinners/in-page-spinner";
import moment from "moment";
import {
	RequestLogsModal,
	SelectedPropertyForRequestLogModal,
} from "./modals/request-logs";
import { useDebounce } from "rooks";
import styles from "./styles.module.scss";
import { RefreshedAgo } from "./RefreshedAgo";
import { BottomPanel } from "./components/BottomPanel";
import CustomDateTimePicker, { DatePickerValue } from "@components/form/date-picker";
import { Checkbox } from "@components/form/elements";
import { ViewRequestDataModal } from "./modals/request-data-logs";
import { errorAlert, infoAlert, successAlert } from "@components/toastify/notify-toast";
import { isEmpty } from "lodash";
import { ViewLogsRequestDataModal } from "./modals/view-audit-request--logs";
import { ViewProgressRequestDataModal } from "./modals/view-progress-request";
import { TooltipTop } from "@components/tooltips";
import { Flex } from "@components/ui/Flex";
import HierarchyView from "./components/Hierarchy";
import { Text } from "@components/ui/Text";
import { errorHandlerFor400 } from "@api/services/errorhandler";
import { ModelRequestType } from "./components/Hierarchy/constant";
import ModelRequestsLists from "./components/Hierarchy/modelRequestsLists";
import { DeleteConfirm } from "@pages/admin/asset_heirarchy/confirm";
import { BsArrowLeft } from "react-icons/bs";
import { JobStatusIcon } from "@pages/workflow-page/assets/icons";
import { useHistory } from "react-router-dom";

const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = "MM/DD/YYYY HH:mm";

type PiRequestModalInfo = {
	type: NewEditPiRequestModalTypes;
	selectedPiRequestInfo: PiRequestInfo | null;
	property: SelectedPropertyForRequestLogModal;
};

type NodeStatus = {
	online: boolean;
	error: string[];
  } | undefined;

const REQUEST_TIME_RANGES = [
	{
		key: "all-time",
		label: "All Time",
		from: null,
		to: null,
	},
	{
		key: "last-24-hours",
		label: "Last 24 Hours",
		from: moment().subtract(1, "days").toISOString().split('.')[0],
		to: null,
	},
	{
		key: "last-72-hours",
		label: "Last 72 Hours",
		from: moment().subtract(3, "days").toISOString().split('.')[0],
		to: null,
	},
	{
		key: "last-week-days",
		label: "Last Week",
		from: moment().subtract(1, "weeks").toISOString().split('.')[0],
		to: null,
	},
	{
		key: "custom",
		label: "Custom Date",
	}
];

const numberOfStates = Object.keys(PiRequestStates).length;

const sinkType = { 
	"AzureEventHub": "Azure Event Hub",
	"S3": "S3",
	"Kinesis": "Kinesis",
	"AzureBlob": "Azure Blob",
	"ADLSGen2":"ADLS Gen 2"	
}

const DataSourceBrowser: React.FC = () => {
	const [activeDataBrowserTab, setActiveDataBrowserTab] = useState(
		dataBrowserTabs.connections
	);
	const [recordsInfo, setRecordsInfo] = useState<{
		content: RecordsInfo;
		totalCount: number;
	}>({ totalCount: 0, content: [] });
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(25);
	const {
		isColumnManagementMinimized,
		showConnectionsTreeview,
	} = useSelector((store: RootState) => store.NewDataSourceReducer);
	const { allUsersList } = useSelector(
		(store: RootState) => store.AccountReducer
	);
	const [activeRecordsMetadata, setActiveRecordsMetadata] = useState<
		TableMetaData
	>({ connectionId: 0, tableName: "", connectionName: "", sourceType: "" });
	const [searchString, setSearchString] = useState("");
	const [allPIServerList, setAllPIServerList] = useState<_selectoptionType[]>(
		[]
	);
	const [formValuesForEdit,setFormValuesForEdit]=useState<ModelRequestType | null>(null);
	const [showDeletePopup, setShowDeletePopup] = useState(false);
	const [selectedModelReqData, setSelectedModelReqData] = useState<ModelRequestType | null>(null);
	const [piServerLoading, setPiServerLoading] = useState(true);
	const [piFilterLoading, setPiFilterLoading] = useState(false);
	const [piSelectedStates, setPiSelectedStates] = useState<string[]>(Object.keys(PiRequestStates));
	const [sinkSelectedStates, setSinkSelectedStates] = useState<string[]>(["ADLSGen2","AzureBlob","AzureEventHub","Kinesis","S3"]);
	const [isViewDataModalOpen,setIsViewDataModalOpen] = useState(false);
	const [viewDataModal,setViewDataModal] = useState<string[]>([]);
	const [isViewLogsModalOpen,setIsViewLogsModalOpen] = useState(false);
	const [viewLogsModalData,setViewLogsModalData] = useState<AuditRequestHistoryType[]>([]);
	const [progressModalOpen,setProgressModalOpen] = useState(false);
	const [viewProgressModalData,setViewProgressModalData] = useState<FileInfo[]>([]);
	const [currProgressRequest,setCurrProgressRequest] = useState<PiRequestInfo | undefined>(undefined)
	const [currPiRequest,setCurrPiRequest] = useState<PiRequestInfo | undefined>(undefined)
	const [enableScaling,setEnableScaling] = useState(false);
	const [showHierarchy,setShowHierarchy] = useState(false);
	const [selectedModelRequestId,setSelectedModelRequestId] = useState<number|null>(null);
	const [selectedModelRequestName,setSelectedModelRequestName] = useState<string|null>(null);
	const [selectedModelRequestPublishedDate,setSelectedModelRequestPublishedDate] = useState<Date>(new Date());
	const [showViewJobBtn,setShowViewJobBtn] = useState<boolean>(false);
	const [selectedModelRequestDagId,setSelectedModelRequestDagId] = useState<string|null>(null);
	const [showModelReqListing,setShowModelReqListing] = useState(true);
	const [hasShownModelReqListing, setHasShownModelReqListing] = useState(false);
	const [ModelRequestsData,setModelRequestsData] = useState<ModelRequestType[]|null>(null);
	const [ModelRequestsFilteredResults, setModelReqFilteredResults] = useState<ModelRequestType[]|null>([])
	const [isLoadingModelReq,setIsLoadingModelReq] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const history = useHistory();
	const showRequestPage = !showHierarchy && !showModelReqListing;
	const { envVariables: Env } = useSelector((store:RootState)=> store.AccountReducer);
	const paginateRef = useRef<PaginateRef>(null);
	const dispatch = useDispatch();
	const state: any = {
		dateRange: [],
		tags: "",
		serverName: "",
		startDate: "",
		endDate: "",
	};
	const [piRequestModalInfo, setPiRequestModalInfo] = useState<
		PiRequestModalInfo
	>({
		type: "new",
		selectedPiRequestInfo: null,
		property: "warning",
	});

	const [bottomTabOpen, setBottomTabOpen] = useState(false);	
	const [isConnectionErrorRead, setIsConnectionErrorRead] = useState(false);
	const [showAllLogsView, setAllLogsView] = useState(false);
	const [piNodes, setPiNodes] = useState<any>({});
	const [nodeStatus, setNodeStatus] = useState<NodeStatus>(undefined)
	const [sinkTypeOptions, setSinkTypeOptions] = useState<string[]>(
		[]
	);

	useEffect(() => {
		if (showModelReqListing) {
			setHasShownModelReqListing(true);
		} else if (!showHierarchy && !showRequestPage) {
			setHasShownModelReqListing(false);
		}
	}, [showModelReqListing, showHierarchy, showRequestPage]);

	useEffect(() => {
		if(isEmpty(activeRecordsMetadata?.afStructureDto)){
			setHasShownModelReqListing(false);
		}
	}, [activeRecordsMetadata]);

	useEffect(() => {
		if (!piNodes?.data?.Edge || !activeRecordsMetadata?.connectionType) {
			setNodeStatus(undefined);
			return;
		}

		const managedConnectionTypes = [
			"Edge_Managed",
			"Edge_Managed_Oracle",
			"Edge_Managed_FTP"
		] as const;

		const connectionType = activeRecordsMetadata.connectionType;
		const sourceType = activeRecordsMetadata.sourceType;

		if (sourceType && managedConnectionTypes.includes(connectionType as any)) {
			const sourceTypeData = piNodes.data.Edge[sourceType] as Record<string, any[]> | undefined;
			const edgeData = sourceTypeData?.[connectionType];
			
			if (Array.isArray(edgeData)) {
				const activeConnection = edgeData.find(
					(node: any) => node.nodeName === activeRecordsMetadata.managedNodeInfo?.nodeName
				) as NiFiManagedConnectionInfo | undefined;

				if (activeConnection?.node) {
					if (nodeStatus?.online && !activeConnection.node.online) {
						setIsConnectionErrorRead(false);
					}
					setNodeStatus({
						online: activeConnection.node.online,
						error: activeConnection.node.error || [],
					});
				}
			}
		} else {
			setNodeStatus(undefined);
		}
	}, [piNodes, activeRecordsMetadata, nodeStatus?.online]);

	const showIP21RDBMSView = (activeRecordsMetadata?.sourceType === "Relational" && (activeRecordsMetadata?.connectionType === "Edge_Managed"));
	const showIP21AspenView = (activeRecordsMetadata?.sourceType === "AspenIP21" && (activeRecordsMetadata?.connectionType === "Edge_Managed"));
	const showOSIPIView = (activeRecordsMetadata?.sourceType === "OSIPI" && (activeRecordsMetadata?.connectionType === "Edge_Managed"));
	const getAllModelRequests = ()=>{
		DataSourceHandler.GetAllModelRequests(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`,activeRecordsMetadata?.nodeName||"",activeRecordsMetadata?.connectionName|| "", (res) => {
			setModelRequestsData(res);
			setIsLoadingModelReq(false);
		}, (err: any) => {
			errorHandlerFor400(err);
			setIsLoadingModelReq(false);
		});
	}
	useEffect(()=>{
		if(Env?.REACT_APP_PLATFORM_URL && ((!isEmpty(activeRecordsMetadata.connectionName) && !isEmpty(activeRecordsMetadata?.afStructureDto?.serverName) && !isEmpty(activeRecordsMetadata?.afStructureDto?.databaseName))||showIP21RDBMSView || showIP21AspenView || showOSIPIView)){
			setIsLoadingModelReq(true);
			setShowModelReqListing(true);
			setShowHierarchy(false);
			getAllModelRequests();
			DataSourceHandler.GetSinkType(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, (res) => {
				// TODO: remove after demo
				setSinkTypeOptions(
					res.sort().filter((s: string)=>![""].includes(s)).map((_res: any) => {
						return _res
					})
				);
			});
		}
	},[Env?.REACT_APP_PLATFORM_URL,activeRecordsMetadata])

	useEffect(() => {
		if(isEmpty(activeRecordsMetadata?.afStructureDto?.serverName) && isEmpty(activeRecordsMetadata?.afStructureDto?.databaseName) && !showIP21RDBMSView && !showIP21AspenView){
			setShowModelReqListing(false);
			setShowHierarchy(false);
		}
	}, [activeRecordsMetadata?.afStructureDto,showIP21RDBMSView,showIP21AspenView]);

	const tableContent = useMemo(
		() =>
			recordsInfo.content.map((cont: RecordsInfo) => {
				const user = allUsersList.find(
					(user) => user.email === cont.createdBy
				);
				cont.userName = user
					? `${user.firstName} ${user.lastName}`
					: cont.createdBy;
				return cont;
			}),
		[recordsInfo]
	);

	const sourceDataForTable: string[][] = useMemo(() => {
		if (activeRecordsMetadata.connectionName === "PI") {
			recordsInfo.content.unshift([
				"Tag name",
				"Date",
				"Value",
				"Quality",
			]);
			// gridRef.current?.forceUpdateGrids();
			// cache.clearAll();
			return recordsInfo.content;
		}
		if (recordsInfo.totalCount !== 0 && recordsInfo.content.length !== 0) {
			const _recordsInfo = recordsInfo.content.map(
				(_record: { [s: string]: any }) =>
					Object.values(_record).map((_value) => {
						if (typeof _value === "object") {
							_value = JSON.stringify(_value);
						}
						return _value;
					})
			);
			// Add column names
			_recordsInfo.unshift(Object.keys(recordsInfo.content[0]));
			// if content count is same between renders, it doesnt re-render
			// gridRef.current?.forceUpdateGrids();
			// // reset cell and column width
			// cache.clearAll();
			return _recordsInfo;
		}
		return [];
	}, [recordsInfo]);

	const handleSetRecordsInfo = (data: RecordsInfoResponse) => {
		setRecordsInfo({
			totalCount: data.totalElements,
			content: data.content,
		});
	};

	const retrieveRecords = ({
		connectionId = activeRecordsMetadata.connectionId,
		tableName = activeRecordsMetadata.tableName,
		pageNo = 1,
		pageSize = numberOfItemsPerPage,
		searchText = searchString,
	}) => {
		if(activeRecordsMetadata.connectionType !== 'Edge_Managed_Oracle' && activeRecordsMetadata.connectionType !== 'Edge_Managed_FTP'){
		DataSourceHandler.GetRecords(
			`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`,
			{ connectionId, tableName, pageNo, pageSize, searchText },
			handleSetRecordsInfo
		);
	}
	};

	const handlePageChange = (pageNo: number) => {
		if (isNifiManagedConnection) {
			handleSetPiRequestQueryInfo({ page: pageNo });
		} else {
			retrieveRecords({ pageNo });
		}
	};

	const getPiServerList = (tableInfo: TableMetaData) => {
		setPiServerLoading(true);
		DataSourceHandler.GetPIServer(
			`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`,
			tableInfo.connectionId,
			(data: any) => {
				setAllPIServerList(
					data.all_servers_list.map((_data: any) => {
						return {
							label: _data,
							value: _data,
						};
					})
				);
				setPiServerLoading(false);
			},
			() => {
				setPiServerLoading(false);
			}
		);
	};

	const handleGetRecords = (tableInfo: TableMetaData) => {
		setSelectedModelRequestId(null);
		setSelectedModelRequestName(null);
		setSelectedModelRequestDagId(null);
		setPiRequestQueryInfo((prev) => {
			const { connectionName, nodeKind, ...rest } = prev as any;
		  
			return {
			  ...rest,
			  modelRequestId: null,
			  ...(tableInfo?.sourceType === "OSIPI"
				? {
					connectionName: tableInfo.connectionName,
					nodeKind: tableInfo.managedNodeInfo?.nodeKind,
				  }
				: {}),
			};
		  });
		  
		setActiveRecordsMetadata(tableInfo);
		if(tableInfo.connectionType !== ConnectionTypes['NiFi Managed'] && tableInfo.connectionType !== 'Edge_Managed_Oracle' && tableInfo.connectionType !== 'Edge_Managed_FTP') {
			if (tableInfo.connectionType === "PI") {
				getPiServerList(tableInfo);
			} else {
				retrieveRecords(tableInfo);
				paginateRef.current?.resetPagesToStartPage();
			}	
		}
		
	};

	const handlePageOptionClick = (newPageSize: number) => {
		setNumberOfItemsPerPage(newPageSize);
		if (isNifiManagedConnection) {
			// page number is reset to 1 on changing page size
			handleSetPiRequestQueryInfo({ size: newPageSize, page: 1 });
		} else {
			retrieveRecords({ pageSize: newPageSize });
		}
	};

	const _retrieveRecordsUsingSearch = useDebounce((searchText: string) => {
		retrieveRecords({ searchText });
	}, 400);

	const handleQueryEditorBuilderSubmit = (query: string) => {
		return query;
	};

	const getPIData = (dat: any = "") => {
		dat.preventDefault();
		setPiFilterLoading(true);
		DataSourceHandler.GetPIData(
			`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`,
			activeRecordsMetadata.connectionId,
			{
				attr_type: "PI_Server",
				pi_server: state.serverName,
				Value_type: "RecordedValues",
				custom_start_time: state.startDate,
				custom_end_time: state.endDate,
				tag_file_path: state.tags,
				site_id: 2,
			},
			(data: any) => {
				setPiFilterLoading(false);
				setRecordsInfo({
					totalCount: data.tags.length,
					content: data.tags,
				});
			},
			() => {
				setPiFilterLoading(false);
			}
		);
	};

	const handleResetRecords = () => {
		setRecordsInfo({ content: [], totalCount: 0 });
		setActiveRecordsMetadata({
			connectionId: 0,
			tableName: "",
			connectionName: "",
			sourceType: ""
		});
	};

	const { isNifiManagedConnection, showBottomHelpTab } = useMemo(
		() => {
			const isNifiManagedConnection = 
			activeRecordsMetadata.connectionType === ConnectionTypes["NiFi Managed"] ||
			activeRecordsMetadata.connectionType === ConnectionTypes["NiFi Managed FTP"];
					  return {
				isNifiManagedConnection,
				showBottomHelpTab: isNifiManagedConnection && activeRecordsMetadata.sourceType === SourceTypes.OSIPI
			}
		},
		[activeRecordsMetadata]
	);

	const [lastRefreshedAt, setLastRefreshedAt] = useState(new Date());

	const [showRefreshPiLoader, toggleRefreshPiLoader] = useState(false);
	const {
		value: createdDateRange,
		setValue: setCreatedDateRange,
	} = CustomDateTimePicker.useCustomRangeController();
	const [showDateRange, setShowDateRange] = useState(false);

	const [activeSortColumn, setActiveSortColumn] = useState<ActiveSortColumn>({
		columnKey: "stateUpdatedDate",
		type: "DESC",
	});

	const [piRequestQueryInfo, setPiRequestQueryInfo] = useState<
		PiRequestQuery
	>({
		page: 1,
		modelRequestId:selectedModelRequestId,
		size: numberOfItemsPerPage,
		sort: `${
			activeSortColumn.columnKey
		},${activeSortColumn.type.toLowerCase()}`,
		state: piRequestStateOptions.map((state) => state.value),
		filter: "",
		creationDateTo: null,
		creationDateFrom: null,
	});

	const isFetchingPiRequestsRef = useRef(false);

	const getNodePiRequests = useDebounce(
		(nodeName: string, showLoader = true) => {
			if (isFetchingPiRequestsRef.current) return;
			isFetchingPiRequestsRef.current = true;
			if (showLoader) {
				toggleRefreshPiLoader(true);
			}
			if (activeRecordsMetadata.connectionType === "Edge_Managed" && activeRecordsMetadata.sourceType === "OPCUA") {
				piRequestQueryInfo.sinkKind = [''];
			}

			DataSourceHandler.GetRequestsOfPiNode(
				`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`,
				nodeName,
				piRequestQueryInfo,
				(res) => {
					isFetchingPiRequestsRef.current = false;
					setRecordsInfo({
						content: res.requests.map((request) => ({
							...request,
							created: moment(request.created).format("LLL"),
							updated: request.stateUpdatedDate ? moment(request.stateUpdatedDate).format("MMM D, YYYY h:mm:ss A") : "",
						})),
						totalCount: res.totalItems,
					});
					setEnableScaling(res.enableScaling)
					// paginateRef.current?.resetPagesToStartPage();
					toggleRefreshPiLoader(false);
					setLastRefreshedAt(new Date());
				},
				(err: any) => {
					isFetchingPiRequestsRef.current = false;
					toggleRefreshPiLoader(false);
					errorHandlerFor400(err);
				}
			);
		},
		400
	);

	const prevNodeNameRef = useRef<string | undefined>();
	const prevConnectionTypeRef = useRef<string | undefined>();
	const prevQueryInfoRef = useRef<string>('');
	const isFirstMountRef = useRef<boolean>(true);
	const prevShowRequestPageRef = useRef<boolean>(false);
	
	useEffect(() => {
		// Get current values
		const currentNodeName = activeRecordsMetadata.managedNodeInfo?.nodeName || activeRecordsMetadata.nodeName;
		const currentConnectionType = activeRecordsMetadata.connectionType;
		const currentQueryString = JSON.stringify(piRequestQueryInfo);
		
		// Check if this is a meaningful change
		const nodeChanged = prevNodeNameRef.current !== currentNodeName;
		const connectionChanged = prevConnectionTypeRef.current !== currentConnectionType;
		const queryChanged = prevQueryInfoRef.current !== currentQueryString && prevQueryInfoRef.current !== '';
		const isFirstMount = isFirstMountRef.current;
		const showRequestPageChanged = prevShowRequestPageRef.current !== showRequestPage && showRequestPage === true;
		
		// Allow API call on first mount OR when showRequestPage becomes true OR when there are meaningful changes
		if(showRequestPage && (isFirstMount || showRequestPageChanged || nodeChanged || connectionChanged || queryChanged)){
			if (isNifiManagedConnection && activeRecordsMetadata.managedNodeInfo?.nodeName) {
				getNodePiRequests(activeRecordsMetadata.managedNodeInfo.nodeName);
			}else if(activeRecordsMetadata.connectionType == "Edge_Managed_Oracle"){
				getNodePiRequests(activeRecordsMetadata.managedNodeInfo?.nodeName);
			}else if(activeRecordsMetadata.connectionType == 'Edge_Managed_FTP'){
				getNodePiRequests(activeRecordsMetadata.managedNodeInfo?.nodeName);
			}else if(activeRecordsMetadata.connectionType == 'Edge_Managed'){
				getNodePiRequests(activeRecordsMetadata.nodeName);
			}
		}
		
		// Update refs for next comparison
		prevNodeNameRef.current = currentNodeName;
		prevConnectionTypeRef.current = currentConnectionType;
		prevQueryInfoRef.current = currentQueryString;
		isFirstMountRef.current = false;
		prevShowRequestPageRef.current = showRequestPage;
		
	}, [piRequestQueryInfo, activeRecordsMetadata.managedNodeInfo?.nodeName, activeRecordsMetadata.nodeName, activeRecordsMetadata.connectionType, isNifiManagedConnection, showRequestPage]);

	useEffect(() => {
		handleSetPiRequestQueryInfo({state: (piSelectedStates.length ? piSelectedStates : ["NONE"]) as PiRequestStates[]});
	},[piSelectedStates]);

	useEffect(() => {
			handleSetSinkRequestQueryInfo({sinkKind: (sinkSelectedStates.length ? sinkSelectedStates : ["NONE"]) as PiRequestStates[]});
	},[sinkSelectedStates]);

	const showCreatePiRequestModal = () => {
		dispatch(toggleDataBrowserModal("newPiRequest", true));
		setPiRequestModalInfo({
			selectedPiRequestInfo: null,
			type: "new",
			property: piRequestModalInfo.property,
		});
	};

	const refreshActivePrRecords = useCallback((showLoader = false) => {
		if(activeRecordsMetadata.managedNodeInfo?.nodeName){
			getNodePiRequests(activeRecordsMetadata.managedNodeInfo.nodeName, showLoader);
		}
	}, [activeRecordsMetadata.managedNodeInfo?.nodeName, getNodePiRequests]);

	const handleSetPiRequestQueryInfo = (
		updatedQuery: Partial<PiRequestQuery>
	) => {
		setPiRequestQueryInfo((piRequestQueryInfo) => ({
			...piRequestQueryInfo,
			...updatedQuery,
		}));
	};

	const handleSetSinkRequestQueryInfo = (
		updatedQuery: Partial<PiRequestQuery>
	) => {
		setPiRequestQueryInfo((piRequestQueryInfo) => ({
			...piRequestQueryInfo,
			...updatedQuery,
		}));
	};

	const handleSearchTags = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchString(e.target.value);
		if (isNifiManagedConnection || activeRecordsMetadata.connectionType == "Edge_Managed_Oracle" || activeRecordsMetadata.connectionType == "Edge_Managed_FTP") {
			handleSetPiRequestQueryInfo({ filter: e.target.value });
		} else {
			_retrieveRecordsUsingSearch(e.target.value);
		}
	};

	const handleViewRequest = (requestInfo: PiRequestInfo) => {
		dispatch(toggleDataBrowserModal("newPiRequest", true));
		DataSourceHandler.GetViewReqJson(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, `${requestInfo.id}`, (response:PiRequestInfo) => {
			setPiRequestModalInfo({
				selectedPiRequestInfo: response,
				type: requestInfo.state === PiRequestStates.New ? "edit" : "view",
				property: piRequestModalInfo.property,
			});
		});
	};

	const handleViewData = (requestInfo:PiRequestInfo) =>{
		setIsViewDataModalOpen(true);
		DataSourceHandler.GetViewReqJson(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, `${requestInfo.id}`, (response:PiRequestInfo) => {
			setViewDataModal(response.data);
		});
	}

	const handleAuditLogsResponse=(data:AuditRequestHistoryType[])=>{
		if(isEmpty(data)){
			infoAlert("No logs found!");
		}else{
			setIsViewLogsModalOpen(true);
			setViewLogsModalData(data);
		}
		toggleRefreshPiLoader(false);
	}

	const handleProgressLogsResponse=(data: any)=>{
		if(isEmpty(data)){
			infoAlert("No logs found!");
		}else{
			setProgressModalOpen(true);
			setViewProgressModalData(data[0]?.fileInfo);
		}
		toggleRefreshPiLoader(false);
	}
	
	const handleViewLogs = (data:PiRequestInfo) =>{
		toggleRefreshPiLoader(true);
		DataSourceHandler.GetAuditReqHistory(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, `${data.id}`, (response:AuditRequestHistoryType[]) => {
            DataSourceHandler.GetAllConnectionsInfo(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, ()=>handleAuditLogsResponse(response));
			
		});
		setCurrPiRequest(data);
	}

	const handleViewProgress = (data: any) => {
		toggleRefreshPiLoader(true);
		const requestId = `${data.id}`; 
		DataSourceHandler.GetProgressReqHistory(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, requestId, (response: ProgressLogsResponse[]) => {
		  handleProgressLogsResponse([response]);
		});
		setCurrProgressRequest(data);
	  };

	const onViewRequestDataClose =()=>{
		setIsViewDataModalOpen(false);
	}
	
	const onViewLogsRequestDataClose =()=>{
		setIsViewLogsModalOpen(false);
		setViewLogsModalData([]);
	}

	const onProgressRequestDataClose =()=>{
		setProgressModalOpen(false);
	}
	
	const handleViewRequestLog = (
		requestInfo: PiRequestInfo,
		property: SelectedPropertyForRequestLogModal
	) => {
		dispatch(toggleDataBrowserModal("requestLogs", true));
		DataSourceHandler.GetViewReqJson(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, `${requestInfo.id}`, (response:PiRequestInfo) => {
			setPiRequestModalInfo({
				selectedPiRequestInfo: response,
				type: piRequestModalInfo.type,
				property,
			});
		});
	};

	const onRefreshBtnClick = () => {
		toggleRefreshPiLoader(true);
		refreshActivePrRecords(true);
	};

	const goToAirflowDagPage = () => {
		const url = `/airflow?dagId=${encodeURIComponent(selectedModelRequestDagId||"")}`;
		window.open(url, '_blank');
	};

	const handleSetActiveSortColumn = useCallback(
		(activeSortColumn: ActiveSortColumn) => {
			setActiveSortColumn(activeSortColumn);
			handleSetPiRequestQueryInfo({
				sort: `${
					activeSortColumn.columnKey
				},${activeSortColumn.type.toLowerCase()}`,
			});
		},
		[]
	);

	const handleCreatedDate = useCallback((value: string) => {
		if(value === "custom") {
			setShowDateRange(true);
		} else {
			setShowDateRange(false);
			setCreatedDateRange(null);
		}

		const range = REQUEST_TIME_RANGES.find((r) => r.key === value);
		handleSetPiRequestQueryInfo({
			creationDateFrom: range?.from,
			creationDateTo: range?.to,
		});
	}, []);

	const handleSetCreatedDateRange = useCallback((value: DatePickerValue<'range'>) => {
		setCreatedDateRange(value)
		handleSetPiRequestQueryInfo({
			creationDateFrom: value?.[0]?.startOf('day').toISOString().split('.')[0] || null, 
			creationDateTo: value?.[1]?.endOf('day').toISOString().split('.')[0] || null, 
		})
	}, [])

	const showConnectionError = () => {
		setAllLogsView(false);
		dispatch(toggleDataBrowserModal("requestLogs", true));
		setPiRequestModalInfo({
			selectedPiRequestInfo: null,
			type: piRequestModalInfo.type,
			property: 'error'
		});
		setIsConnectionErrorRead(true);
	}

	const showConnectionLogs= () => {
		dispatch(toggleDataBrowserModal("requestLogs", true));
		setPiRequestModalInfo({
			selectedPiRequestInfo: null,
			type: piRequestModalInfo.type,
			property: 'warning'
		});
		setAllLogsView(true);
	}

	const handleEdit = (item: ModelRequestType) => {
		const openEditForm = (modelRequest: ModelRequestType) => {
			setFormValuesForEdit(modelRequest);
			setSelectedModelRequestName(modelRequest.modelRequestName);
			setSelectedModelReqData(modelRequest);
			setShowModelReqListing(false);
			setShowHierarchy(true);
		};

		if (showIP21AspenView) {
			setIsLoadingModelReq(true);
			DataSourceHandler.GetModelRequest(
				`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`,
				item.id,
				(response: ModelRequestType | { data: ModelRequestType }) => {
					const modelRequest = "data" in response ? response.data : response;
					setIsLoadingModelReq(false);
					openEditForm(modelRequest);
				},
				(error: any) => {
					setIsLoadingModelReq(false);
					errorHandlerFor400(error);
				}
			);
			return;
		}

		openEditForm(item);
    }

    const handleViewRequests = (item: ModelRequestType) => {
		toggleRefreshPiLoader(true);
		setRecordsInfo({ content: [], totalCount: 0 });
		setPiRequestQueryInfo((piRequestQueryInfo) => ({
			...piRequestQueryInfo,
			modelRequestId: item.id,
		}));
		const createdAt = new Date(item?.created);
 		const createdAtPlusOneMinute = new Date(createdAt.getTime() + 60 * 1000);
		setSelectedModelRequestPublishedDate(createdAtPlusOneMinute)
		setSelectedModelRequestName(item.modelRequestName);
		setSelectedModelRequestId(item.id);
		setSelectedModelRequestDagId(item?.dagGenDto?.dag_id||null);
		setShowHierarchy(false);
		setShowModelReqListing(false);
    }

	useEffect(() => {
		if (!selectedModelRequestPublishedDate) return;
	  
		const now = new Date();
		const timeUntilEnable = selectedModelRequestPublishedDate.getTime() - now.getTime();
	  
		if (timeUntilEnable > 0) {
		  setShowViewJobBtn(true);
	  
		  const timer = setTimeout(() => {
			setShowViewJobBtn(false);
		  }, timeUntilEnable);
	  
		  return () => clearTimeout(timer);
		} else {
		  setShowViewJobBtn(false);
		}
	  }, [selectedModelRequestPublishedDate]);
	
    const handleDeleteConfirm = (item: ModelRequestType) => {
		setShowDeletePopup(true);
        setSelectedModelReqData(item);
    }

	const Wrapper = ({ children }: { children: React.ReactElement }) => {
		if (isLoadingModelReq) {
			return (
				<div className={stylesHierachy["centerLoading"]}>
					<InPageSpinner size="Large" color="white" />
				</div>
			);
		}
		return <div className="mt-1">{children}</div>;
	};

	const searchData = (text: string) => {
        setSearchTerm(text);
        setModelReqFilteredResults(
            ModelRequestsData?.filter((data) =>
                data.modelRequestName.toLowerCase().includes(text.toLowerCase())
            ) || []
        );
    };

	const filteredModelReqData = searchTerm.length === 0
	? ModelRequestsData
	: ModelRequestsFilteredResults

	const handleResetRequestPage = () => {
		setShowHierarchy(false);
		setShowModelReqListing(true)
		getAllModelRequests();
	}

	const handleNewConnectionClick = () => {
		dispatch(setActionType('NEW'))
		dispatch(toggleDataBrowserModal('newEditConnection', true));
	  };
	
	const handleDelete = () => {
        if (selectedModelReqData?.id) {
			setIsLoadingModelReq(true);
            DataSourceHandler.DeleteModelRequest(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, selectedModelReqData?.id || 0, (res) => {
                getAllModelRequests();
                setIsLoadingModelReq(false);
                setSelectedModelReqData(null);
                setShowDeletePopup(false);
                successAlert(res)
            }, (e: any) => {
                setIsLoadingModelReq(false);
                errorAlert(e.data)
                setSelectedModelReqData(null);
                setShowDeletePopup(false);
            });
        }
    }

	  let displayText: string;

if (activeRecordsMetadata.connectionType === ConnectionTypes["NiFi Managed"]) {
    displayText = `${sourceTypeNameMapping[activeRecordsMetadata.sourceType]} (Edge Managed)`;
} else if (activeRecordsMetadata.connectionType === 'Edge_Managed_Oracle') {
    displayText = `Relational (Edge Managed Oracle)`;
} else if(activeRecordsMetadata.connectionType === 'Edge_Managed_FTP'){
	displayText = `Object Storage (Edge Managed FTP)`;
} else {
    displayText = "Table";
}

	return (
		<section className="dataSourceBrowser__container">
			<div
				className={classNames("treeview__container", {
					"treeview--minimized": !showConnectionsTreeview,
				})}
			>
				<p className="LHS__title">Data Browser</p>
				<ul className="switchable__tabs__outer">
					{dataTabsList.map((tab) => (
						<li
							key={tab}
							className={classNames("switchable__tab", {
								"switchable__tab--active":
									activeDataBrowserTab === tab,
							})}
							onClick={() => setActiveDataBrowserTab(tab)}
						>
							{tab}
						</li>
					))}
				</ul>
				<ConnectionsTreeview
					handleGetRecords={handleGetRecords}
					handleResetRecords={handleResetRecords}
					handleNodeUpdate={setPiNodes}
				/>
			</div>
			<div
				className={classNames(
					"workflow__master__container dataSourceBrowser__outer",
					{ fullWidthMode: isColumnManagementMinimized }
				)}
			>
				{/* <CanvasTabsComponent
					handlePlusIconClick={() => {
						return;
					}}
					openTabs={new Map()}
					activeTab={0}
					switchTab={() => {
						return;
					}}
					closeTab={() => {
						return;
					}}
					updateOpenTabs={() => {
						return;
					}}
					showSavedStatus={false}
					hidePlusIcon
				/> */}

				<div
					className={classNames("dataSourceBrowser__canvas", {
						hidePadding: !activeRecordsMetadata.tableName,
						// "dataSourceBrowser__canvas--with-bottom-tab": showBottomHelpTab,
					})}
				>
					{activeRecordsMetadata.tableName ? (
						<div className="innerCanvas">
							<div className="dataSourceBrowser__header">
								<ShowWhenTrue
									show={
										activeRecordsMetadata.connectionName !==
										"PI"
									}
								>
									<p className={classNames("noStatus__table__title", {
										"dataSourceBrowser__table__title": nodeStatus !== undefined,
										"connection-offline": nodeStatus !== undefined && !nodeStatus.online,
									})}>
										{displayText}
										:
										<span>
											&nbsp;
											{activeRecordsMetadata.connectionType === ConnectionTypes["NiFi Managed"] ?
											activeRecordsMetadata.tableName:`${activeRecordsMetadata.tableName}(${activeRecordsMetadata.managedNodeInfo?.nodeName})`}

										</span>
										<ShowWhenTrue show={showRequestPage}>
											{ isNifiManagedConnection &&
												<button className={classNames(styles.piConnectionErrorButton, {[styles.read]: isConnectionErrorRead})} onClick={showConnectionError}>
													<img src="/icons/data-browser/error.svg" alt="" />
												</button>
											}
											{ isNifiManagedConnection &&
												<button className={classNames(styles.piConnectionErrorButton)} onClick={showConnectionLogs}>
													<img src="/icons/data-browser/view.svg" alt="" />
												</button>
											}
										</ShowWhenTrue>
										{/* <button
                                            className="btn-md btn-grey btn-openQueryModal"
                                            onClick={() => dispatch(toggleDataBrowserModal('queryEditorBuilder' ,true))}
                                        >
                                        Query
                                        </button> */}
									</p>
								</ShowWhenTrue>
								<ShowWhenTrue
									show={
										activeRecordsMetadata.connectionName ===
										"PI"
									}
								>
									<p>{activeRecordsMetadata.tableName}</p>
								</ShowWhenTrue>
								<ShowWhenTrue
									show={
										activeRecordsMetadata.connectionType !==
										ConnectionTypes["NiFi Managed"] &&
										!showIP21RDBMSView &&
										!showIP21AspenView
									}
								>
									<p className="dataSourceBrowser__header__connectionName">
										Connection:
										<span>
											&nbsp;
											{
												activeRecordsMetadata.connectionName
											}
										</span>
									</p>

								</ShowWhenTrue>

								<Flex gap="20px" alignItems={"center"} flexWrap="wrap">
									<ShowWhenTrue show={Env?.REACT_ENABLE_PI_REQUEST_HIERARCHY}>
										<ShowWhenTrue show={showModelReqListing}>
											<button
												className="btn btn-md btn-yellow-transparent"
													onClick={()=>{
														toggleRefreshPiLoader(true);
														setRecordsInfo({ content: [], totalCount: 0 });
														setPiRequestQueryInfo((prev) => ({
															...prev,
															modelRequestId: null,
															...(activeRecordsMetadata?.sourceType === "OSIPI"
																? {
																	connectionName: activeRecordsMetadata.connectionName,
																	nodeKind: activeRecordsMetadata.managedNodeInfo?.nodeKind,
																}
																: activeRecordsMetadata?.sourceType === "AspenIP21"
																	? {
																		connectionName: activeRecordsMetadata.connectionName,
																	}
																	: {}),
														}));
														setSelectedModelRequestId(null);
														setShowModelReqListing(false);
														setShowHierarchy(false);	
														setSelectedModelRequestName(null);
														setSelectedModelRequestDagId(null);
													}}
											>
												Requests
											</button>
										</ShowWhenTrue>
									</ShowWhenTrue>
									{/* { isNifiManagedConnection && 
										<button
											className={styles.dataBrowserHelp}
											onClick={() => {
												setBottomTabOpen(true);
												setBottomTabIndex(0);
											}}
										>
											<DsIcon name="help" />
											Help
										</button>
									} */}
								</Flex>
							</div>
							<ShowWhenTrue
								show={
									activeRecordsMetadata.connectionName ===
									"PI"
								}
							>
								<div
									className="dataSourceBrowser__header"
									style={{
										width: "100%",
										display: "inline-block",
									}}
								>
									<AntForm
										onSubmit={getPIData}
										//onFinish={onFinish}
										//onFinishFailed={onFinishFailed}
									>
										<Row gutter={[16, 16]}>
											<Col span={2}>
												<p className="dataSourceBrowser__table__title">
													Filter:
												</p>
											</Col>
											<Col span={6}>
												<Select
													placeholder="Select PI Server"
													style={{
														width: "100%",
													}}
													allowClear
													notFoundContent="No PI Server found"
													loading={piServerLoading}
													onChange={(_data) => {
														state.serverName = _data;
													}}
												>
													{allPIServerList.map(
														(d) => (
															<Option
																key={d.value}
															>
																{d.label}
															</Option>
														)
													)}
												</Select>
											</Col>
											<Col span={6}>
												<Input
													onChange={(e) => {
														state.tags =
															e.target.value;
													}}
													placeholder="Enter Tag(s) Name"
													prefix={
														<Icon
															type="search"
															style={{
																color: "white",
															}}
														/>
													}
												/>
											</Col>
											<Col span={6}>
												<RangePicker
													format={dateFormat}
													showTime={{
														format: "HH:mm",
													}}
													onChange={(_data) => {
														state.startDate = _data[0]?.format(
															"DD-MMM-YYYY HH:mm:ss"
														);
														state.endDate = _data[1]?.format(
															"DD-MMM-YYYY HH:mm:ss"
														);
													}}
													onOk={() => {
														return;
													}}
													style={{
														marginRight: "10px",
													}}
												/>
											</Col>
											<Col span={2}>
												<Button
													type="primary"
													loading={piFilterLoading}
													icon="search"
													htmlType="submit"
												>
													Search
												</Button>
											</Col>
										</Row>
									</AntForm>
								</div>
							</ShowWhenTrue>
							<ShowWhenTrue show={showRequestPage}>
								<div>
									<ShowWhenTrue
										show={
											activeRecordsMetadata.connectionName !==
											"PI"
										}
									>
										<Flex
											className={styles.piRequestMainActions}
										>
											<Flex>
												{showRequestPage && <>
													<ShowWhenTrue show={showRequestPage && hasShownModelReqListing}>
														<button
															className="btn btn-yellow btn-md"
															onClick={()=>{setShowHierarchy(false),setShowModelReqListing(true);setSelectedModelRequestDagId(null)}}
															>
																<Flex gap={"5px"} alignItems={"center"}>
																	<BsArrowLeft />
																	<span>Back</span>
																</Flex>
														</button>
													</ShowWhenTrue>
												</>}
											</Flex>
											<Flex>
												<ShowWhenTrue show={activeRecordsMetadata.connectionType === ConnectionTypes["NiFi Managed"] || activeRecordsMetadata.connectionType == 'Edge_Managed_Oracle' || activeRecordsMetadata.connectionType == 'Edge_Managed_FTP'}>
													<div className={styles.actions}>
														<ShowWhenTrue show={showRequestPage && !isEmpty(selectedModelRequestDagId)}>
															<button
																className="btn btn-md btn-grey-transparent"
																onClick={goToAirflowDagPage}
																disabled={isEmpty(selectedModelRequestDagId) || showViewJobBtn}
															>
																<Flex  alignItems={"center"}>
																	<JobStatusIcon/>
																	View Jobs
																</Flex>
															</button>
														</ShowWhenTrue>
														<button
															className="btn btn-yellow btn-md"
															onClick={
																showCreatePiRequestModal
															}
														>
															<img src="/icons/data-browser/add.svg" />
															<span>Request</span>
														</button>
														<button
															className="btn btn-md btn-grey-transparent"
															id="refreshPiRequests"
															onClick={onRefreshBtnClick}
															disabled={showRefreshPiLoader}
														>
															{showRefreshPiLoader ? (
																<InPageSpinner
																	size="XSmall"
																	color="black"
																/>
															) : (
																<>
																	<img src="/icons/data-browser/refresh.svg" />
																	Refresh
																</>
															)}
														</button>
													</div>
												</ShowWhenTrue>
											</Flex>
										</Flex>
										<ShowWhenTrue show={showRequestPage && !isEmpty(selectedModelRequestDagId)}>
											<Flex
												className={styles.piRequestMainActions}
											>
												<Flex>
													<TooltipTop title={selectedModelRequestName}>
													<div className="hierarchyName">
														{selectedModelRequestName ? `Edge Data Pipeline : ${selectedModelRequestName}` : "Edge Data Pipeline"}
													</div>
												</TooltipTop>
											</Flex>
											<Flex>
												<span className={styles.timeAgo}>
													<RefreshedAgo
														time={lastRefreshedAt}
													/>
												</span>
											</Flex>
										</Flex>
										</ShowWhenTrue>
										<ShowWhenTrue show={activeRecordsMetadata.connectionType === ConnectionTypes["NiFi Managed"] || activeRecordsMetadata.connectionType == 'Edge_Managed_Oracle' || activeRecordsMetadata.connectionType == 'Edge_Managed_FTP'}>
											<div className={styles.piRequestFilters}>
												<div>
													<label>Search</label>
													<input
														onChange={handleSearchTags}
														className="search_input"
														placeholder="Search by ID or Name or Request body"
														value={searchString}
													/>
												</div>
												{!(activeRecordsMetadata.connectionType === "Edge_Managed" && activeRecordsMetadata.sourceType === "OPCUA")
												&& (<div className={styles.piSelect}>
													<label>Sink</label>
													<div className={styles.piSelectStateWrapper}>
														<Select
															style={{width: '100%'}}
															size="large"
															optionLabelProp="label"
															mode="multiple"
															className="piStateSelect"
															value={sinkSelectedStates}
															showArrow
															dropdownRender={menu => (
																<>
																	<div className={styles.piSelectSelectAll} onMouseDown={(e) => e.preventDefault()} onClick={
																		() => {
																			setSinkSelectedStates(sinkSelectedStates.length === sinkTypeOptions.length ? [] : Object.values(sinkTypeOptions));
																		}
																	}>
																		<Checkbox
																			partiallySelected={sinkSelectedStates.length !== sinkTypeOptions.length && sinkSelectedStates.length > 0}
																			checked={sinkSelectedStates.length === sinkTypeOptions.length}
																			color="gold"
																			onClick={(e) =>{e.preventDefault()}}
																		/>
																		Select All
																	</div>
																	{menu}
																</>
															)}
															suffixIcon={<img src="/icons/data-browser/down.svg"/>}
															onChange={(v: string[]) => {
																setSinkSelectedStates(v);
															}}
														>
															{
																sinkTypeOptions.map((item) => {
																	const sinkLabel = sinkType[item as keyof typeof sinkType]
																	return(
																	<Option className="piStateSelectItem" key={item} label={sinkLabel}>
																		<div className={styles.sinkLabel}> 
																			<span>{sinkLabel}</span>
																		</div>
																	</Option>
																)})
															}
														</Select>
													</div>
												</div>)}
												<div className={styles.piSelect}>
													<label>State</label>
													<div className={styles.piSelectStateWrapper}>
														<Select
															style={{width: '100%'}}
															size="large"
															optionLabelProp="label"
															mode="multiple"
															className="piStateSelect"
															value={piSelectedStates}
															showArrow
															dropdownRender={menu => (
																<>
																	<div className={styles.piSelectSelectAll} onMouseDown={(e) => e.preventDefault()} onClick={
																		() => {
																			setPiSelectedStates(piSelectedStates.length === numberOfStates ? [] : Object.keys(PiRequestStates));
																		}
																	}>
																		<Checkbox
																			partiallySelected={piSelectedStates.length !== numberOfStates && piSelectedStates.length > 0}
																			checked={piSelectedStates.length === numberOfStates}
																			color="gold"
																			onClick={(e) =>{e.preventDefault()}}
																		/>
																		Select All
																	</div>
																	{menu}
																</>
															)}
															suffixIcon={<img src="/icons/data-browser/down.svg"/>}
															onChange={(v: string[]) => {
																setPiSelectedStates(v);
															}}
														>
															{
																(Object.keys(PiRequestStates) as (keyof typeof PiRequestStates)[]).map((state) => (
																	<Option className="piStateSelectItem" key={state} label={PiRequestStates[state]}>
																		<div className={classNames(styles.requestState, styles[PiRequestStates[state]])}>
																			<span>{PiRequestStates[state]}</span>
																		</div>
																	</Option>
																))
															}
														</Select>
													</div>
												</div>
												<div className={styles.piSelect}>
													<label>Show Requests Created</label>
													<Select
														className="piRangeSelect"
														size="large"
														defaultValue={'all-time'}
														suffixIcon={<img src="/icons/data-browser/down.svg"/>}
														onChange={handleCreatedDate}
													>
														{
															REQUEST_TIME_RANGES.map(time => (
																<Option className="piRangeSelectItem"  key={time.key}>{time.label}</Option>
															))
														}
													</Select>
												</div>
												<div className={classNames(styles.piRequestCustomDateRange, {[styles.show]: showDateRange})}>
													<CustomDateTimePicker
														startRangeLabel="Date Range"
														type="range"
														value={createdDateRange} 
														setRangeValue={handleSetCreatedDateRange}
														disableFutureDates
													/>
												</div>
											</div>
										</ShowWhenTrue>
									</ShowWhenTrue>
									{sourceDataForTable.length ? (
										<>
											{activeRecordsMetadata.connectionType ===
											ConnectionTypes["NiFi Managed"] || activeRecordsMetadata.connectionType=='Edge_Managed_Oracle'
											|| activeRecordsMetadata.connectionType=='Edge_Managed_FTP'? (
												<PiManagedRequestsTable
													data={tableContent}
													refreshActivePrRecords={
														refreshActivePrRecords
													}
													viewRequest={handleViewRequest}
													viewRequestLog={
														handleViewRequestLog
													}
													activeSortColumn={
														activeSortColumn
													}
													setActiveSortColumn={
														handleSetActiveSortColumn
													}
													loading={showRefreshPiLoader}
													viewData={handleViewData}
													viewLogs={handleViewLogs}
													viewProgress={handleViewProgress}
													connectionType={activeRecordsMetadata.connectionType}
													sourceType={activeRecordsMetadata.sourceType}
													nodeStatus={activeRecordsMetadata.managedNodeInfo?.online ?? false}
													enableScaling={enableScaling}
												/>
											) : (
												<AdjustToCellSizeTable
													data={sourceDataForTable}
												/>
											)}
											<TablePagination
												handlePageChange={handlePageChange}
												handleItemsPerPageOptionClick={
													handlePageOptionClick
												}
												totalNoOfRecords={
													recordsInfo.totalCount
												}
												numberOfItemsPerPage={
													numberOfItemsPerPage
												}
												showNumberOfItemsPerPageDropdown
											/>
										</>
									) : (
										showRefreshPiLoader ? (
											<InPageSpinner
												size="XSmall"
												color="white"
											/>
										):(
											<div className="noworkflows__msg">
												No Data Available
											</div>
										)
									)}
								</div>
							</ShowWhenTrue>
							<ShowWhenTrue show={showHierarchy}>
								<Flex
									className={styles.piRequestMainActions}
								>
									<Flex>{(isNifiManagedConnection || showIP21RDBMSView || showIP21AspenView) &&<>
										<ShowWhenTrue show={!showModelReqListing}>
											<button
												className="btn btn-yellow btn-md"
												onClick={()=>{setShowHierarchy(false),setShowModelReqListing(true);setSelectedModelRequestDagId(null)}}
											>
												<Flex gap={"5px"} alignItems={"center"} justifyContent={"center"}>
													<BsArrowLeft />
													<span>Back</span>
												</Flex>
											</button>
										</ShowWhenTrue>
										</>}
									</Flex>
									<Flex gap="20px">
										<ShowWhenTrue show={!isEmpty(activeRecordsMetadata?.afStructureDto?.serverName) && !isEmpty(activeRecordsMetadata?.afStructureDto?.databaseName)}>
											<Flex>
												<Text fontSize="16px" color="white">
													Server:&nbsp;
												</Text>
												<Text fontSize="16px" color="#D3D3D3">
													{activeRecordsMetadata?.afStructureDto?.serverName}
												</Text>
											</Flex>
											<Flex>
												<Text fontSize="16px" color="white">
													Database:&nbsp;
												</Text>
												<Text fontSize="16px" color="#D3D3D3">
													{activeRecordsMetadata?.afStructureDto?.databaseName}
												</Text>
											</Flex>
										</ShowWhenTrue>
									</Flex>
								</Flex>
								<ShowWhenTrue show={showRequestPage && !isEmpty(selectedModelRequestDagId)}>
									<Flex className={styles.piRequestMainActions}>
										<Flex>
											<TooltipTop title={selectedModelRequestName}>
											<div className="hierarchyName">
												{selectedModelRequestName ? `Edge Data Pipeline : ${selectedModelRequestName}` : "Edge Data Pipeline"}
											</div>
										</TooltipTop>
									</Flex>
								</Flex>
								</ShowWhenTrue>
								<HierarchyView isRDBMSView={showIP21RDBMSView} isAspenView={showIP21AspenView} activeRecordsMetadata={activeRecordsMetadata}  handleGoToReqPage={()=>handleResetRequestPage()} formValuesForEdit={formValuesForEdit} setFormValuesForEdit={setFormValuesForEdit}/>
							</ShowWhenTrue>
							<ShowWhenTrue show={showModelReqListing}>
								<Wrapper>
									<div>
										<div className={stylesHierachy["search_container"]}>
											<ShowWhenTrue show={!isLoadingModelReq && !isEmpty(ModelRequestsData)}>
												<div
													className={classNames(
														"search__input__container",
														stylesHierachy["search_container"]
													)}
												>
													<input
														autoFocus
														className={classNames(
															"search_input",
															stylesHierachy["search_input"]
														)}
														placeholder="Search"
														value={searchTerm}
														onChange={(e) => searchData(e.target.value)}
													/>
													{searchTerm.length === 0 ? null : (
														<img
															src="/icons/treeview/search-cross.svg"
															alt=""
															className="search_reset"
															style={{
																top: 26,
															}}
															onClick={() => {
																searchData("");
															}}
														></img>
													)}
												</div>
											</ShowWhenTrue>
											<ShowWhenTrue show={!isEmpty(activeRecordsMetadata?.afStructureDto?.serverName) && !isEmpty(activeRecordsMetadata?.afStructureDto?.databaseName) || showIP21RDBMSView || showIP21AspenView}>
												<div className="newBtn__box">
													<button 
														id="Btn_NewConnection"
														className="btn-md btn-yellow-transparent btn__new__workflow btn__new__action" 
														onClick={()=>{setFormValuesForEdit(null);setSelectedModelRequestId(null);setSelectedModelRequestName(null);setSelectedModelRequestDagId(null);setShowHierarchy(!showHierarchy),setShowModelReqListing(!showModelReqListing)}}
													>
														<img src="/icons/workflow/add.svg" alt="" /> 
														<span>Edge Data Pipeline</span>
													</button>
												</div>
											</ShowWhenTrue>
										</div>
										<DeleteConfirm
											onConfirm={() => handleDelete()}
											showModal={showDeletePopup}
											title={`Are you sure you want to delete the ${selectedModelReqData?.modelRequestName || ""} Edge Data Pipeline?`
											}
											toggleClose={() => {
												setSelectedModelReqData(null);
												setShowDeletePopup(false);
											}}
										/>
										<ShowWhenTrue show={!isLoadingModelReq && isEmpty(ModelRequestsData)}>
											<div className={stylesHierachy["centerLoading"]}>
												<h3 className="white">No Data Available. 
													{/* Please Create a New Edge Data Pipeline. */}
													</h3>
											</div>
										</ShowWhenTrue>
										<ShowWhenTrue show={!isLoadingModelReq && !isEmpty(ModelRequestsData)}>
											<ModelRequestsLists isRdbmsView={showIP21RDBMSView} data={filteredModelReqData} handleDelete={handleDeleteConfirm} handleEdit={handleEdit} handleViewRequests={handleViewRequests} />
										</ShowWhenTrue>
									</div>
								</Wrapper>
							</ShowWhenTrue>
							{/* <div className={classNames('queryEditorMaster', {'hide': activeInsideTab !== dataBrowserInsideTabs.query})}>
                            <button 
                                className="btn__queryBuilder"
                            >
                                Query Builder 
                                <OpenQueryBuilderIcon />
                            </button>
                            <div className="editorHeader">
                                <button
                                    onClick={handleCopyEditorText}
                                >
                                    <CopyIcon /> Copy
                                </button>
                                <button
                                    onClick={handleClearEditor}
                                >
                                    <ClearIcon /> Clear
                                </button>
                            </div>
                            <Form
                                initialValues={{}}
                                onSubmit={() => {return;}}
                            >
                                <EditorField
                                    name="test" 
                                />
                            </Form>
                            <div className="actionButtons__box">
                                <button
                                    className="btn-md btn-yellow"
                                >
                                    Run
                                </button>
                                <button
                                    className="btn-md btn-yellow-transparent"
                                >
                                    Save
                                </button>
                            </div>
                            <div className="queryList__box">
                                <ul className="switchable__tabs__outer">
                                    {queryBrowserTabsList.map(_tab => (
                                        <li 
                                            className={classNames('switchable__tab', {'switchable__tab--active': _tab === activeQueryBrowserTab})}
                                            onClick={() => setActiveQueryBrowserTab(_tab)}
                                            key={_tab}
                                        >
                                            {_tab}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            
                        </div> */}
						</div>
					) : (
						<div className="noworkflows__msg databrowserEmptyCanvas">
								<span
									onClick={handleNewConnectionClick}
									className="workflow__actions"
								>
									Create a New Connection
								</span>
						</div>
					)}
				</div>

				{showBottomHelpTab && (
					<BottomPanel
						open={bottomTabOpen}
						onMinimize={() => setBottomTabOpen(false)}
					/>
				)}
			</div>
			<ColumnManagementRhs />
			<QueryEditorBuilderModal
				onSubmit={handleQueryEditorBuilderSubmit}
			/>
			<NewEditPiRequestModal
				activeRecordsMetadata={activeRecordsMetadata}
				refreshActivePrRecords={refreshActivePrRecords}
				modelRequestId={selectedModelRequestId||null}
				{...piRequestModalInfo}
			/>
			<ShowWhenTrue show={!showAllLogsView}>
				<RequestLogsModal
					property={piRequestModalInfo.property}
					logs={(piRequestModalInfo.selectedPiRequestInfo ? piRequestModalInfo.selectedPiRequestInfo[piRequestModalInfo.property] : nodeStatus?.error) || activeRecordsMetadata.managedNodeInfo?.error||[]}
					name={(piRequestModalInfo.selectedPiRequestInfo?.id || 'connection') as string} />
			</ShowWhenTrue>
			<ShowWhenTrue show={showAllLogsView}>
				<RequestLogsModal
					property={piRequestModalInfo.property}
					logs={(piRequestModalInfo.selectedPiRequestInfo ? piRequestModalInfo.selectedPiRequestInfo[piRequestModalInfo.property] : activeRecordsMetadata.managedNodeInfo?.logs) ||[]}
					name={(piRequestModalInfo.selectedPiRequestInfo?.id || 'connection') as string} />
			</ShowWhenTrue>
			
			<ViewRequestDataModal 
				isOpen={isViewDataModalOpen} 
				data={viewDataModal} 
				onClose={onViewRequestDataClose}/>
			<ViewLogsRequestDataModal 
				isOpen={isViewLogsModalOpen} 
				data={viewLogsModalData} 
				onClose={onViewLogsRequestDataClose}
				title={`Request # ${currPiRequest?.id} (${currPiRequest?.requestName}) Status Logs`}
			/>
			<ViewProgressRequestDataModal 
				isOpen={progressModalOpen} 
				data={viewProgressModalData} 
				onClose={onProgressRequestDataClose}
				title={`Request # ${currProgressRequest?.id} Progress Logs`}
			/>
		</section>
	);
};

export default DataSourceBrowser;